export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
}

export function formatDate(value: string): string {
  const parts = value.split('-');
  if (parts.length !== 3) {
    return value;
  }
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}